import TriggerConfig from 'eflex/models/trigger-config';

export default class PlcHardwareTriggerConfig extends TriggerConfig {}
